import useMutationApi from 'src/api/useMutationApi';
import { DivisionDTO } from '@erp/shared-types';

interface UpdateDivisionRequest {
  name?: string;
  metadata?: Record<string, unknown> | null;
}

interface UpdateDivisionResponse {
  division: DivisionDTO;
}

const useUpdateDivision = (
  divisionId: string,
  onSuccess?: (division: DivisionDTO) => void,
) => {
  return useMutationApi<UpdateDivisionRequest, UpdateDivisionResponse>({
    endpoint: `organization/divisions/${divisionId}`,
    method: 'PUT',
    options: {
      onSuccess: onSuccess
        ? (res) => {
            onSuccess(res.data.division);
          }
        : undefined,
    },
  });
};

export default useUpdateDivision;
